import { Icon } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'

const STATES = {
  on: {
    icon: 'status-on',
    color: 'secondary-10',
  },
  off: {
    icon: 'status-blocked',
    color: 'text-error',
  },
  archived: {
    icon: 'status-archive',
    color: 'basic-secondary-grey',
  },
  suspended: {
    icon: 'status-finished',
    color: 'secondary-13',
  },
  off_by_monitoring: {
    icon: 'status-blocked',
    color: 'text-error',
  },
}

export const StateIcons = ({ state = null }) => {
  const currentStatus = STATES?.[state]

  if (!currentStatus) {
    return '—'
  }

  const { icon, color } = currentStatus

  return (
    <Icon
      color={color}
      name={icon}
      size={'s'}
    />
  )
}

StateIcons.propTypes = {
  state: PropTypes.string,
  className: PropTypes.string,
  component: PropTypes.elementType,
}
